import { BoundStandardSwitch } from "lib/@components/binding/bound-components"
import { Alert, Box } from "@mui/material"
import { FEATURE_FLAG_API_USE_UNIQUE_CODE } from "routes/sharing/api-feature-flags"
import { Feature } from "lib/@components/feature"

export function UseUniqueCodeShareLinkSetting() {
    return (
        <Feature feature={FEATURE_FLAG_API_USE_UNIQUE_CODE}>
            <Box data-cy="use-unique-code-toggle">
                <BoundStandardSwitch
                    sideEffects
                    field="useUniqueCode"
                    label="Use unique code as schedule code in the API"
                />
                <Alert severity="info">
                    When enabled, the API will return the unique code from custom schedules instead of the SFG20
                    generated code. Schedules without a unique code will continue to use the generated code.
                </Alert>
            </Box>
        </Feature>
    )
}
